<script setup lang="ts">
import { type VNodeRef, computed, onMounted, ref, watch } from "vue"

import JsBarcode from "jsbarcode"

const props = defineProps({
  value: { type: [String, Number], required: true }, // e.g. 12345678
  format: { type: String, default: "CODE128" }, // "CODE128", "EAN13", "EAN8", "CODE39", ...
  displayValue: { type: Boolean, default: false }, // show text under bars
  height: { type: Number, default: 40 }, // bar height
  width: { type: Number, default: 2 }, // bar width
  margin: { type: Number, default: 0 }, // margin around barcode
  text: { type: String, default: "" }, // override human-readable text
})

const svgRef = ref<VNodeRef | null>(null)
const content = computed(() => String(props.value ?? ""))

function render() {
  if (!svgRef.value || !content.value) return
  try {
    JsBarcode(svgRef.value, content.value, {
      format: props.format,
      displayValue: props.displayValue,
      width: props.width,
      height: props.height,
      margin: props.margin,
      text: props.text || undefined,
    })
  } catch (e) {
    // If format/content invalid, clear the SVG
    svgRef.value.innerHTML = ""
  }
}

onMounted(() => {
  render()
})

watch(
  () => [props.value, props.format, props.displayValue, props.width, props.height, props.margin, props.text],
  render,
)
</script>

<template>
  <svg ref="svgRef" class="barcode" role="img" aria-label="Barcode"></svg>
</template>

<style scoped>
.barcode {
  width: 100%;
  height: auto;
}

@media print {
  .barcode {
    shape-rendering: crispEdges;
  }
}
</style>
